import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@rtkwlf/pro-solid-svg-icons/faCheck';
import { faCopy } from '@rtkwlf/pro-solid-svg-icons/faCopy';

import { useFenrirTranslation } from '../../../locales/use-fenrir-translation';
import { IconButton, type IconButtonProps } from '../../icon-button';
import { Tooltip, type TooltipProps } from '../../tooltip';
import { useCopyToClipboardWithReset } from '../use-copy-to-clipboard-with-reset/use-copy-to-clipboard-with-reset';

export interface CopyToClipboardIconButtonProps {
  /**
   * Label for the Tooltip title and IconButton aria-label
   * @default 'Copy to clipboard'
   */
  label?: string;
  value: string;
  slotProps?: {
    button?: Pick<
      IconButtonProps,
      'size' | 'disabled' | 'sx' | 'onFocusVisible' | 'edge'
    >;
    tooltip?: Pick<
      TooltipProps,
      'sx' | 'id' | 'open' | 'onClose' | 'onOpen' | 'placement' | 'slotProps'
    >;
  };
}

export const CopyToClipboardIconButton = ({
  value,
  label: _label,
  slotProps,
}: CopyToClipboardIconButtonProps) => {
  const { t } = useFenrirTranslation({ keyPrefix: 'clipboard' });
  const { copied, copyToClipboard } = useCopyToClipboardWithReset();

  const label = _label ? _label : t('copyToClipboard');

  return (
    // tooltip title adds an aria-label on the children tag
    // Note: Don't use the describeChild prop since the tooltip provides the only visual label.
    <Tooltip title={copied ? t('copied') : label} {...slotProps?.tooltip}>
      <IconButton
        color={copied ? 'info' : 'default'}
        onClick={() => copyToClipboard(value)}
        size="small"
        {...slotProps?.button}
      >
        <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
      </IconButton>
    </Tooltip>
  );
};
